import React, { useState } from "react";
import "./CreateTag.css";

import {
  Box,
  Grid,
  Card,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Stepper,
  Step,
  StepLabel,
} from "@mui/material";

import Step1AdDetails from "./child/Step1AdDetails";
import Step2ChooseCreative from "./child/Step2ChooseCreative";
import Step3GenerateTag from "./child/Step3GenerateTag";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";

const theme = createTheme({
  typography: {
    fontFamily: "'Gilroy-Regular', sans-serif",
  },
});

const steps = ["Ad Details", "Choose Creative", "Generate Tag"];

/* CONSISTENT STYLES */
const primaryButtonSx = {
  background: "#0049AA",
  height: "50px",
  minWidth: "140px",
  fontSize: "15px",
  fontWeight: 500,
  borderRadius: "10px",
  textTransform: "none",
  "&:hover": {
    background: "#003a88",
  },
};

const secondaryButtonSx = {
  height: "50px",
  minWidth: "140px",
  fontSize: "15px",
  borderRadius: "10px",
  textTransform: "none",
};

const sectionTitleSx = {
  fontWeight: 600,
  color: "#0049AA",
  mb: 1,
};

const sectionSubTextSx = {
  color: "#666",
  fontSize: "14px",
  mb: 4,
};

const CreateTag = () => {
  const [activeStep, setActiveStep] = useState(0);

  const [templateName, setTemplateName] = useState(
    "Dynamic Geo Style4 - Half Canvas",
  );
  const [campaignName, setCampaignName] = useState("Meta SMB Campaign");
  const [agencyName, setAgencyName] = useState("");
  const [clientName, setClientName] = useState("Meta");
  const [adType, setAdType] = useState("Banner");
  const [dimension, setDimension] = useState("300×600");
  const [landingPage, setLandingPage] = useState("https://");

  const [uploadedImages, setUploadedImages] = useState([]);
  const [generatedAds, setGeneratedAds] = useState([]);
  const [selectedAd, setSelectedAd] = useState(null);

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  /* IMAGE UPLOAD (MAX 7) */
 const handleImageUpload = (event) => {
  const files = Array.from(event.target.files);
  setError("");

  if (files.length + uploadedImages.length > 7) {
    setError("Maximum 7 files allowed.");
    return;
  }

  const validFiles = [];

  for (let file of files) {
    const type = file.type;

    const isImage =
      type.includes("png") ||
      type.includes("jpg") ||
      type.includes("jpeg");

    const isVideo =
      type.includes("mp4") ||
      type.includes("webm") ||
      type.includes("quicktime"); // mov

    const isPSD = file.name.endsWith(".psd");

    if (!(isImage || isVideo || isPSD)) {
      setError("Only PSD, Images, and Videos (MP4, MOV, WEBM) allowed.");
      continue;
    }

    validFiles.push(file);
  }

  setUploadedImages((prev) => [...prev, ...validFiles]);
};

  /* GENERATE RANDOM 4 */
  const handleGenerateAd = () => {
    if (uploadedImages.length === 0) {
      setError("Upload at least one creative");
      return;
    }

    setLoading(true);
    setError("");

    setTimeout(() => {
      // 🔥 Shuffle + pick 4
      const shuffled = [...uploadedImages].sort(() => 0.5 - Math.random());
      const selected = shuffled.slice(0, 4);

      const ads = selected.map((file) => URL.createObjectURL(file));

      setGeneratedAds(ads);
      setSelectedAd(null); // reset selection
      setLoading(false);
      setActiveStep(1);
    }, 2000);
  };

  const handleNext = () => setActiveStep((prev) => prev + 1);
  const handleBack = () => setActiveStep((prev) => prev - 1);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <Box sx={{ p: 3 }}>
        
        <Stepper activeStep={activeStep} sx={{ mb: 4 }}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        <Card sx={{ borderRadius: "16px", p: 3 }}>
          {activeStep === 0 && (
            <Step1AdDetails
              sectionTitleSx={sectionTitleSx}
              sectionSubTextSx={sectionSubTextSx}
              primaryButtonSx={primaryButtonSx}
              templateName={templateName}
              setTemplateName={setTemplateName}
              campaignName={campaignName}
              setCampaignName={setCampaignName}
              agencyName={agencyName}
              setAgencyName={setAgencyName}
              clientName={clientName}
              setClientName={setClientName}
              adType={adType}
              setAdType={setAdType}
              dimension={dimension}
              setDimension={setDimension}
              landingPage={landingPage}
              setLandingPage={setLandingPage}
              handleImageUpload={handleImageUpload}
              uploadedImages={uploadedImages}
              handleGenerateAd={handleGenerateAd}
              loading={loading}
            />
          )}

          {activeStep === 1 && (
            <Step2ChooseCreative
              sectionTitleSx={sectionTitleSx}
              sectionSubTextSx={sectionSubTextSx}
              primaryButtonSx={primaryButtonSx}
              secondaryButtonSx={secondaryButtonSx}
              generatedAds={generatedAds}
              selectedAd={selectedAd}
              setSelectedAd={setSelectedAd}
              handleBack={handleBack}
              handleNext={handleNext}
            />
          )}

          {activeStep >= 2 && (
            <Step3GenerateTag
              sectionTitleSx={sectionTitleSx}
              sectionSubTextSx={sectionSubTextSx}
              secondaryButtonSx={secondaryButtonSx}
              handleBack={handleBack}
              handleNext={handleNext}
            />
          )}
          {error && (
            <Typography color="error" sx={{ mt: 2 }}>
              {error}
            </Typography>
          )}
        </Card>
      </Box>
    </ThemeProvider>
  );
};

export default CreateTag;
